import PageContainer from '@/common/components/PageContainer'
import ProfileListing from '@/modules/profile/components/ProfileListing'

export default function ProfilePage() {
	return (
		<PageContainer>
			<ProfileListing />
		</PageContainer>
	)
}
